<div class="overlay text-center">
    <i class="fas fa-2x fa-sync-alt fa-spin"></i>
</div>